import VueHtml2pdf from 'vue-html2pdf';
import { PdfPages } from '@/enums/PdfPages';
import imageToBase64 from 'image-to-base64/browser';

export default {
  name: "Pdf",
  components: {
    VueHtml2pdf
  },
  props: {
    page: {
      type: String,
    },
    data: {
      type: Array,
    }
  },
  data() {
    return {
      list: [],
      loading: {
        component: true,
        download: false,
      },
      number: 10,
      staff: [
        /*{
          column: this.$t("GeneralTranslations.ProfilePicture"),
          value: "thumbnailUrl"
        },*/
        {
          column: this.$t("GeneralTranslations.NameOfStaff"),
          value: "name"
        },
        {
          column: this.$t("GeneralTranslations.Email"),
          value: "email"
        },
        {
          column: this.$t("GeneralTranslations.Roles"),
          value: "roles"
        }
      ],
      residents: [
        /*{
          column: this.$t("GeneralTranslations.ProfilePicture"),
          value: "thumbnailUrl"
        },*/
        {
          column: this.$t("GeneralTranslations.NameOfResident"),
          value: "name"
        },
        {
          column: this.$t("ResidentsList.PreferredName"),
          value: "pname"
        },
        {
          column: this.$t("GeneralTranslations.Wing"),
          value: "wingName"
        },
        {
          column: this.$t("GeneralTranslations.Room"),
          value: "roomName"
        },
      ],
    }
  },
  async mounted() {
    await this.generatePdfData(this.data);
  },
  computed: {
    header(): string {
      switch(this.page) {
        case PdfPages.StaffList:
          return this.staff;
        case PdfPages.ResidentsList:
          return this.residents;
      }
    }
  },
  methods: {
    async generatePdfData(data) {
      const arr = JSON.parse(JSON.stringify(data));

      // TODO: Fix CORS issue
      /*const settled = await (Promise as any).allSettled(
        arr.slice(0, this.number).map(async (x) => {
          const base64Data = await imageToBase64(x.thumbnailUrl ?? x.imageUrl ?? x.profilePicUrl)
            .catch(() => {
              console.log("BASE 64 ERROR ", x.id, x.name);
              return null;
            });

          return {
            ...x,
            thumbnailUrl: base64Data && base64Data.length > 200 ? `data:image/png;base64,${base64Data}` : null
          };
        })
      );

      this.list = settled
        .filter(r => r.status === "fulfilled")
        .map(r => r.value);*/

      this.list = arr;

      this.loading.component = false;
    },
    download(): void {
      this.loading.download = true;
      this.$refs.html2Pdf.generatePdf();
    },
    downloaded(): void {
      this.loading.download = false;
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.loading.component = true;
        this.generatePdfData(newVal);
      }
    }
  }
}